module.exports = __webpack_public_path__ + "static/media/tiles-newAudit.38f807f7.svg";